import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
	padding: 64px;
	box-sizing: border-box;
	position: relative;
`;

export const Card = styled.div`
	background: linear-gradient(
		135deg,
		${({ theme }) => theme.gray[200]} 0%,
		${({ theme }) => theme.gray[100]} 100%
	);
	border-radius: 16px;
	padding: 64px 80px;
	max-width: 600px;
	width: auto;
	position: relative;
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	text-align: center;
	flex-shrink: 0;

	// Grid pattern overlay
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-image: linear-gradient(${({ theme }) => theme.gray[400]}33 1px, transparent 1px),
			linear-gradient(90deg, ${({ theme }) => theme.gray[400]}33 1px, transparent 1px);
		background-size: 40px 40px;
		pointer-events: none;
		opacity: 0.5;
	}
`;

export const Content = styled.div`
	position: relative;
	z-index: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
`;

export const LoaderWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 8px;
`;

export const Title = styled.h1`
	font-size: 32px;
	font-weight: 700;
	margin: 0;
	color: ${({ theme }) => theme.gray[1000]};
	font-family: 'Inter', sans-serif;
`;

export const Subtitle = styled.p`
	font-size: 16px;
	color: ${({ theme }) => theme.gray[700]};
	line-height: 1.6;
	margin: 0;
	font-family: 'Inter', sans-serif;
	max-width: 500px;
`;
